import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/finally';

import { User, Subscription } from '../../../entities/index';
import { SubscriptionService } from '../../../services/subscription.service';

@Component({
  selector: 'app-linked-subscriptions',
  templateUrl: './linked-subscriptions.html'
})
export class LinkedSubscriptionsComponent {
  _user: User;
  subscriptions: Subscription[] = [];
  loading = false;

  constructor(protected router: Router, protected subscriptionService: SubscriptionService) {
  }

  @Input()
  set user(user: User) {
    this.subscriptions = [];
    if (user && !!user.id) {
      this.loading = true;
      this.subscriptionService
        .listByUser(user)
        .finally(() => this.loading = false)
        .subscribe((subscriptions: Subscription[]) => {
          this.subscriptions = subscriptions;
        });
    }
    this._user = user;
  }

  get user() {
    return this._user;
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/blocks/linked-subscriptions/linked-subscriptions.component.ts